import React, { useEffect, useState } from "react";
import { CustomStackFullWidth } from "../../../styled-components/CustomStyles.style";
import {
  alpha,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { t } from "i18next";
import { Box } from "@mui/system";
import { getCurrentModuleType } from "../../../helper-functions/getCurrentModuleType";
import { getLanguage } from "../../../helper-functions/getLanguage";
import CustomImageContainer from "../../CustomImageContainer";
import DollarSignHighlighter from "../../DollarSignHighlighter";
import down_arrow from "../assets/downarrow.png";
import HeroLocationForm from "./HeroLocationForm";
import ModuleSelectionRaw from "./module-selection/ModuleSelectionRaw";
import DownArrow from "../assets/DownArrow";
import { useDispatch } from "react-redux";
import useGetModule from "../../../api-manage/hooks/react-query/useGetModule";
import { setModules } from "../../../redux/slices/configData";

const HeroTitleSection = ({ configData, landingPageData, handleOrderNow }) => {
  const theme = useTheme();
  const isXSmall = useMediaQuery(theme.breakpoints.down("sm"));
  const currentLanguage = getLanguage();
  const [currentLocation, setCurrentLocation] = useState(null);
  const dispatch = useDispatch();
  const { data: moduleData, refetch } = useGetModule();

  useEffect(() => {
    if (typeof window !== "undefined") {
      const location = window.localStorage.getItem("location");
      setCurrentLocation(location);

      // Listen for changes to localStorage
      const handleStorageChange = (e) => {
        if (e.key === "location") {
          setCurrentLocation(e.newValue);
          refetch(); // Refetch modules when location changes
        }
      };
      window.addEventListener("storage", handleStorageChange);
      return () => window.removeEventListener("storage", handleStorageChange);
    }
  }, [refetch]);

  useEffect(() => {
    if (moduleData?.length > 0) {
      dispatch(setModules(moduleData));
    }
  }, [moduleData, dispatch]);

  const getSearchOrModulesBySelectedModules = () => {
    if (currentLocation) {
      return <ModuleSelectionRaw location={true} />;
    } else {
      return (
        <CustomStackFullWidth mt="15px">
          <HeroLocationForm />
        </CustomStackFullWidth>
      );
    }
  };

  return (
    <CustomStackFullWidth
      sx={{
        animation: "fadeInUp 1s ease-out",
        "@keyframes fadeInUp": {
          "0%": { opacity: 0, transform: "translateY(20px)" },
          "100%": { opacity: 1, transform: "translateY(0)" },
        },
      }}
    >
      <CustomStackFullWidth spacing={2}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="flex-start"
          spacing={0.5}
          flexWrap="wrap"
        >
          <Typography
            sx={{
              color: (theme) => theme.palette.mode === 'dark' ? theme.palette.text.primary : theme.palette.primary.main,
              fontSize: isXSmall ? "32px" : "72px",
              lineHeight: isXSmall ? "38px" : "82px",
              fontWeight: 800,
              letterSpacing: "-0.02em",
              textShadow: "none"
            }}
          >
            <DollarSignHighlighter
              theme={theme}
              text={landingPageData?.header_title}
            />
          </Typography>
        </Stack>
        <Typography
          sx={{
            color: (theme) => theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.primary.deep,
            fontSize: isXSmall ? "18px" : "28px",
            lineHeight: isXSmall ? "26px" : "38px",
            fontWeight: 500,
            maxWidth: "600px",
            textShadow: "none"
          }}
        >
          <DollarSignHighlighter
            theme={theme}
            text={landingPageData?.header_sub_title}
          />
        </Typography>
      </CustomStackFullWidth>
      <CustomStackFullWidth flexDirection="row" spacing={2} mt="20px" sx={{ position: "relative" }}>
        <Typography
          sx={{
            fontSize: { xs: "14px", md: "18px" },
            color: (theme) => theme.palette.mode === 'dark' ? theme.palette.text.secondary : theme.palette.primary.customType2,
            fontWeight: 400,
            textShadow: "none"
          }}
        >
          <DollarSignHighlighter
            theme={theme}
            text={landingPageData?.header_tag_line}
          />
        </Typography>
        {(!getCurrentModuleType() && !isXSmall) && (<DownArrow />)}
      </CustomStackFullWidth>
      {getSearchOrModulesBySelectedModules()}
    </CustomStackFullWidth>
  );
};

export default HeroTitleSection;
